import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const faqs = [{
  q: '¿Necesito vivir en una capital?',
  a: 'No, solo necesitas internet estable. El trabajo remoto real no discrimina por código postal.'
}, {
  q: '¿Sirve para cualquier profesión?',
  a: 'Sí, siempre que el trabajo se pueda hacer frente a una computadora (diseño, programación, asistencia virtual, ventas, marketing, soporte, etc).'
}, {
  q: '¿Es seguro cobrar desde fuera?',
  a: 'Totalmente, te enseñamos las plataformas legales que usan miles de contratistas en Latam para recibir sus pagos con bajas comisiones.'
}, {
  q: '¿Tengo que renunciar a mi empleo actual ya?',
  a: 'No, puedes empezar el proceso de búsqueda y optimización de perfiles en tus horas libres sin riesgo.'
}, {
  q: '¿El libro está en español?',
  a: 'Sí, todo el contenido educativo está en español para tu mejor comprensión, aunque te enseñamos a preparar tus materiales en inglés.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-navy-800 border-t border-white/5" data-id="element-11">
      <div className="max-w-3xl mx-auto" data-id="element-12">
        <FadeIn data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-14">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-15">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-16">
              <div className="bg-navy-900 rounded-2xl border border-navy-600 overflow-hidden" data-id="element-17">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-18">
                  <span className="text-lg font-semibold text-white pr-8" data-id="element-19">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-accent-400 transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-20" />
                </button>
                <AnimatePresence data-id="element-21">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-22">
                      <div className="px-6 pb-5 text-slate-400" data-id="element-23">{faq.a}</div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}